/* eslint-disable react/button-has-type */
import React, { useEffect, useState, useCallback, useRef, useLayoutEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { bumexFeatureSelectors } from '@panel/core/src/state/ducks/bumexFeatures';
import { userInfoSelectors } from '@panel/core/src/state/ducks/user';
import { sendTrackingInfo } from '@panel/commons';
import Checkbox from '@panel/commons/lib/Input/InputCheckbox';
import { useTranslation } from 'react-i18next';
import { genericFormatAmount } from '@panel/commons/helpers/formatAmount';
import { select } from '@panel/commons/core/themev2';
import { getIsTransitionOrBundleCredit, isPortalWithClonedPostings } from '@panel/commons/helpers';
import cardNoImg from '@panel/commons/assets/icons/aviso-sin-foto.svg';
import { getColor } from '@panel/commons/core/themev3';
import OptionsSelector from '@panel/commons/lib/DropDown/OptionSelector';
import { getLinkToEdit } from '@panel/core/src/utils/getPublisherLinks';
import { PostingsOperations } from '../../../../ducks/posting';
import { ReservationOperations } from '../../../../ducks/reservation';
import { CancelReservationOperations } from '../../../../ducks/cancelReservation';
import Skeleton from '../Skeleton/Skeleton';
import ActionsArea from './ActionsArea';
import BottomInfoRight from './BottomInfo';
import UpperInfoRight from './UpperInfo';
import MiddleInfoRight from './MiddleInfo';
import ModalsArea from './ModalsArea';
import FinishReasonInfo from './FinishReasonInfo';
import { getUrlPosting } from '../../../../helpers/getUrlPosting';
import {
  PostingContainer,
  ImageWrapper,
  InfoLeftArea,
  InfoLabelsWrapper,
  InfoLabel,
  InfoRightArea,
  Reservado,
  LeftArea,
  ReportContainer,
  CardContainer,
  Alert,
  ReportMessage,
  PostingStateLabel,
  TypeAndStateContainer,
  PostingTitle,
  DescriptionArea,
  PostingFooter,
  PostingBody,
  ImageDefault,
  FinishReasonsContainer,
  TagZonaDemand
} from './styles';
import Collapsible from '../../commons/Collapsible';
import QualityArea from './QualityArea';

function MemoizedPosting({
  posting,
  device,
  userCanEditPermissions,
  usedForTour,
  isParticular,
  setFinishedAction,
  isAssistant,
  finishReason,
  loadingFinishReason,
  loadingCredits,
  setMenuOpenId,
  menuOpenId
}) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const {
    fetchQuality,
    fetchPerformanceStatus,
    fetchReports,
    getPostingViewsStats,
    getPostingLogs,
    getFinishReasonByPosting
  } = PostingsOperations;
  const siteId = process.env.REACT_APP_BUILD_SITE;
  const address = posting.postingLocation[0] && posting.postingLocation[0].address;
  const status = posting.stateAndDates[0] && posting.stateAndDates[0].status;
  const {
    pricesOperationTypes,
    isFreemiumFlow,
    postingId,
    urlPosting,
    realEstateType,
    isReservado,
    quality,
    qualityError,
    loadingQuality,
    loadingLeads,
    loadingPerformanceStatus,
    performanceStatusError,
    performanceStatus,
    publicationPlan,
    loadingReports,
    postingReports,
    reportsError,
    socialAdsReport,
    publicationType,
    isDuplicate,
    isPenalized,
    validations,
    qualityStatus,
    loadingLogs,
    logsError,
    postingLogs,
    finishReasonByPosting,
    loadingFinishReasonByPosting,
    finishReasonErrorByPosting,
    publicationPlanId,
    isExclusiveZone
  } = posting;
  const isDraft = status === 'DRAFT';
  const isDeleted = status === 'DELETED';
  const isFinalized = status === 'OFFLINE';
  const onlineStates = ['ONLINE', 'NEAR_END'];
  const withoutCreditState = status === 'WITHOUT_CREDIT';
  const isOnline = onlineStates.includes(status);
  const { lockedSoft, publisherTypeId, isIntegrator } = useSelector(userInfoSelectors.getuserInfoState);
  const newPublisherAccess = ['DVPE', 'UBPE', 'ZPAR', '24MX', 'IWBR', 'WIBR', 'PLEC', 'CAPA', 'CMBR', 'VAMX'];
  const qualityNotApply = qualityStatus === 'not_apply';
  const showEndedReasons = isDeleted || isFinalized;
  const callPerformance = siteId !== 'VAMX';
  const linkToDesempeno = `../panel/desempeno?postingId=${postingId}`;
  const showDesempeno = !isDraft;
  const isFreePlan = publicationPlan && publicationPlan.includes('FREE');
  const totalReport = postingReports && postingReports.totalReport;
  const positionRef = useRef(null);
  const positionRef2 = useRef(null);

  const hasSelectorPosting = getIsTransitionOrBundleCredit(publicationPlanId) && isOnline && isPortalWithClonedPostings;
  const isOpenThisMenu = menuOpenId === postingId;
  const isDevelopment = publicationType === 'Emprendimiento';
  const { bumexFeatures } = useSelector(bumexFeatureSelectors.getBumexFeatureState);

  const linkToPostingUrl = `../${isDraft ? 'preview/' : ''}${t('panel.url.property')}/${getUrlPosting(
    urlPosting,
    postingId
  )}`;

  const [showSelectPosting, setShowSelectPosting] = useState({
    onImage: false,
    onTitle: false,
    onActionButton: false
  });
  const [upPosition, setUpPosition] = useState(false);
  const [activeShadow, setActiveShadow] = useState(false);
  const [showModal, setShowModal] = useState({
    integratorModal: false,
    activationModal: false,
    endModal: false,
    performanceTips: false,
    lockedSoft: false,
    archiveModal: false,
    reportModal: false,
    socialAdsReportModal: false,
    upgradePlanModal: false,
    historyModal: false,
    printModal: false
  });
  const [copyToClipboardMessage, setCopyToClipboardMessage] = useState({ id: '', codigo: '' });
  const [copyTimeOutRef, setCopyTimeOutRef] = useState('');

  const redirectToEdit = openInNewTab => {
    const url = `${window.location.origin}${getLinkToEdit(isParticular, bumexFeatures, postingId, isDevelopment)}`;
    // eslint-disable-next-line no-unused-expressions
    openInNewTab ? window.open(url, '_blank') : (window.location.href = url);
  };

  const handleOutsideClick = onElement => {
    if (onElement) {
      setShowSelectPosting({ onImage: false, onTitle: false, onActionButton: false });
      setActiveShadow(false);
    }
    if (menuOpenId) setMenuOpenId(null);
  };

  const handleCheck = useCallback(() => {
    const checked = !posting.checked;
    dispatch(PostingsOperations.checkPosting(postingId, checked));
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [posting.checked]);

  const openModal = (e, modal) => {
    e.stopPropagation();
    setMenuOpenId(null);
    setShowModal({ ...showModal, [modal]: true });
  };

  const showCopyMessage = () => {
    clearTimeout(copyTimeOutRef);
    setCopyTimeOutRef(
      setTimeout(() => {
        setCopyToClipboardMessage({ id: '', codigo: '' });
      }, 2000)
    );
  };

  const redirectToPosting = hasMirror => {
    if (hasMirror && showSelectPosting.onImage) {
      window.open(`${linkToPostingUrl}?mirror=true`, '_blank');
      sendTrackingInfo('Panel', 'Mis avisos', 'Card del aviso-Imagen-Ir al aviso secundario');
    }
    if (!hasMirror && showSelectPosting.onImage) {
      window.open(linkToPostingUrl, '_blank');
      sendTrackingInfo('Panel', 'Mis avisos', 'Card del aviso-Imagen-Ir al aviso');
    }
    if (hasMirror && !showSelectPosting.onImage) {
      window.open(`${linkToPostingUrl}?mirror=true`, '_blank');
      sendTrackingInfo('Panel', 'Mis avisos', 'Card del aviso-Ir al aviso secundario');
    }
    if (!hasMirror && !showSelectPosting.onImage) {
      window.open(linkToPostingUrl, '_blank');
      sendTrackingInfo('Panel', 'Mis avisos', 'Card del aviso-Ir al aviso');
    }
    setActiveShadow(false);
    setShowSelectPosting({ onImage: false, onTitle: false, onActionButton: false });
  };

  const optionsPostingsArray = () => {
    return [
      { text: t('posting.card.goToPrincipalPosting'), handleOnClick: () => redirectToPosting(), id: '01' },

      { text: t('posting.card.goToClonedPosting'), handleOnClick: () => redirectToPosting(true), id: '02' }
    ];
  };

  const handleMenuClose = e => {
    e.stopPropagation();
    setMenuOpenId(null);
  };

  const handleReservation = event => {
    handleMenuClose(event);
    dispatch(ReservationOperations.savePostingTag(postingId, 1));
  };

  const handleCancelReservation = event => {
    handleMenuClose(event);
    dispatch(CancelReservationOperations.deletePostingTag(postingId, 1));
  };

  const getFormatedPrices = () => {
    const prices = [];
    pricesOperationTypes.forEach(operation => {
      if (operation) {
        const { amountAndCurrency } = operation;
        prices.push({
          operationType: t(`panel.postings.operations.operationType.${operation.operationType}`),
          price:
            amountAndCurrency && amountAndCurrency[0].amount !== 0
              ? genericFormatAmount(amountAndCurrency[0].amount, amountAndCurrency[0].currency)
              : t('panel.posting.no.price'),
          secondPrice:
            amountAndCurrency && amountAndCurrency[1] && amountAndCurrency[1].amount
              ? genericFormatAmount(amountAndCurrency[1].amount, amountAndCurrency[1].currency)
              : ''
        });
      }
    });
    return prices;
  };

  const formatedPrice = getFormatedPrices();

  const processReports = () => {
    if (!postingReports) return;
    const { reports } = postingReports;
    let countNew = 0;
    let countChecked = 0;
    if (!reports) return;
    reports.forEach(rep => {
      countChecked += rep.checked;
      countNew += rep.unChecked;
    });
    // eslint-disable-next-line consistent-return
    return { countNew, countChecked };
  };

  const processedReportCounts = processReports();

  const getQualityText = () => {
    if (qualityNotApply) return 'notApply';
    if (isDuplicate) return 'duplicated';
    if (isPenalized) return 'penalized';
    if (quality >= 0 && !qualityNotApply) return 'ok';
    return 'withoutData';
  };

  const getTooltipText = () => {
    if (isDuplicate) return 'isDuplicated';
    if (isPenalized) return 'isPenalized';
    if (qualityNotApply) return 'withoutData';
    if (quality === 100) return 'complete';
    return 'improvePosting';
  };

  useLayoutEffect(() => {
    // Efecto para posicionar 'hacia arriba' o 'hacia abajo' Selector para ir al aviso (en caso avisos clonados):
    const positionBottom = positionRef.current && positionRef.current.getBoundingClientRect().bottom;
    setUpPosition(positionBottom + 10 >= window.innerHeight);
  }, [showSelectPosting.onImage]);

  useEffect(() => {
    // Se realiza FETCH para traer info de leads (Exposición, Visualizaciones e Interesados):
    dispatch(getPostingViewsStats(postingId));

    // Se realiza FETCH para traer los motivos de finalización por aviso;
    if ((isDeleted || isFinalized) && !loadingFinishReasonByPosting && !finishReasonErrorByPosting)
      dispatch(getFinishReasonByPosting(postingId));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!loadingQuality && !quality && quality !== 0 && !qualityError) {
      dispatch(fetchQuality(postingId));
    }
    if (
      !loadingPerformanceStatus &&
      !performanceStatus &&
      ![null, ''].includes(performanceStatus) &&
      !performanceStatusError &&
      !isDraft &&
      callPerformance
    ) {
      dispatch(fetchPerformanceStatus(postingId));
    }
    if (!loadingReports && !reportsError && !postingReports && !isDraft) {
      dispatch(fetchReports(postingId));
    }
    if (!loadingLogs && !logsError && !postingLogs && !isDraft) {
      dispatch(getPostingLogs(postingId));
    }
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [loadingLeads, loadingQuality, loadingPerformanceStatus, loadingReports, loadingLogs, logsError]);

  useEffect(() => {
    if (copyToClipboardMessage.id || copyToClipboardMessage.codigo) {
      showCopyMessage();
    }
  }, [copyToClipboardMessage.id, copyToClipboardMessage.codigo]);

  if (loadingQuality || (!quality && quality !== 0 && !qualityError)) {
    return <Skeleton />;
  }

  const getInfoRightSection = () => {
    if (showEndedReasons) {
      return (
        <FinishReasonsContainer>
          <FinishReasonInfo
            isDeleted={isDeleted}
            finishReasonByPosting={finishReasonByPosting}
            publisherTypeId={publisherTypeId}
            lockedSoft={lockedSoft}
            openModal={openModal}
            postingId={postingId}
          />
        </FinishReasonsContainer>
      );
    }
    return (
      <InfoRightArea device={device}>
        <UpperInfoRight
          device={device}
          posting={posting}
          linkToDesempeno={linkToDesempeno}
          allowRedirectDesempeno={showDesempeno}
          usedForTour={usedForTour}
          postingStatus={status}
        />
        <MiddleInfoRight device={device} posting={posting} usedForTour={usedForTour} isOnline={isOnline} />
      </InfoRightArea>
    );
  };

  return (
    <>
      <ModalsArea
        posting={posting}
        showModal={showModal}
        setShowModal={setShowModal}
        isFreePlan={isFreePlan}
        publisherTypeId={publisherTypeId}
        redirectToEdit={redirectToEdit}
        socialAdsReport={socialAdsReport}
        isOnline={isOnline}
        isDraft={isDraft}
        isDuplicate={isDuplicate}
        hasReportsUnchecked={processedReportCounts && processedReportCounts.countNew}
        fetchReports={() => dispatch(fetchReports(postingId))}
        postingLogs={postingLogs}
        isIntegrator={isIntegrator}
        setFinishedAction={setFinishedAction}
        isAssistant={isAssistant}
        finishReason={finishReason}
        loadingFinishReason={loadingFinishReason}
        loadingCredits={loadingCredits}
        device={device}
      />

      <PostingContainer
        data-panel='posting'
        postingChecked={posting.checked || isOpenThisMenu || activeShadow || false}
        device={device}
      >
        <CardContainer device={device}>
          <PostingBody>
            <LeftArea device={device}>
              {!isAssistant && (
                <div
                  data-panel={`posting-checkbox-bulk-${postingId}`}
                  className='checkbox-container'
                  onClick={handleCheck}
                >
                  <Checkbox
                    readOnly
                    name={`check-posting-${postingId}`}
                    checked={posting.checked || false}
                    fillColor={getColor('primary')}
                  />
                </div>
              )}
              <ImageWrapper device={device}>
                <div
                  onClick={e => {
                    e.stopPropagation();
                    if (!hasSelectorPosting)
                      sendTrackingInfo('Panel', 'Mis avisos', 'Card del aviso-Imagen-Ir al aviso');
                    if (hasSelectorPosting) {
                      setShowSelectPosting({
                        onImage: !showSelectPosting.onImage,
                        onTitle: false,
                        onActionButton: false
                      });
                      if (!showSelectPosting.onTitle && !showSelectPosting.onActionButton) {
                        setActiveShadow(!activeShadow);
                      }
                      if (menuOpenId) setMenuOpenId(null);
                    }
                  }}
                  data-panel='posting-action-irAviso-picture'
                >
                  <a
                    className='img-hover'
                    href={!hasSelectorPosting ? linkToPostingUrl : null}
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    <p>{t('postings.card.OptionsMenu.goToPosting')}</p>
                  </a>
                </div>
                {isReservado && (
                  <Reservado data-panel='posting-tagReservado' device={device}>
                    Reservado
                  </Reservado>
                )}
                {hasSelectorPosting && showSelectPosting.onImage && (
                  <OptionsSelector
                    isOpen={showSelectPosting.onImage}
                    optionsArray={optionsPostingsArray()}
                    elementRef={positionRef}
                    handleOutsideClick={handleOutsideClick}
                    getTopPosition={upPosition}
                    width='171px'
                    height='94px'
                    topUp='-98px'
                    topDown='100px'
                  />
                )}
                {posting.urlPicture ? (
                  <img
                    data-panel='posting-img'
                    alt='Imagen del aviso'
                    src={posting.urlPicture}
                    onError={({ currentTarget }) => {
                      currentTarget.onerror = null; // previene looping
                      currentTarget.src = cardNoImg;
                      currentTarget.style = `background-color:${select(
                        'grayMedium'
                      )}; object-fit:none; border-radius:8px`;
                    }}
                  />
                ) : (
                  <ImageDefault>
                    <img
                      data-panel='posting-img-sinImagen'
                      alt='Aviso sin imagen'
                      src={cardNoImg}
                      width='102'
                      height='53'
                    />
                  </ImageDefault>
                )}
              </ImageWrapper>
              <InfoLeftArea device={device} showEndedReasons={showEndedReasons}>
                <InfoLabelsWrapper device={device}>
                  <TypeAndStateContainer>
                    <InfoLabel data-panel='posting-realEstateType' darkGray>
                      {realEstateType}
                    </InfoLabel>
                    <PostingStateLabel
                      data-panel='posting-stateLabel'
                      className={`POSTING-STATE-${device.toUpperCase()}`}
                      estado={status}
                    >
                      {t(`panel.posting.status.${status}`)}
                    </PostingStateLabel>
                  </TypeAndStateContainer>
                  <DescriptionArea device={device}>
                    <div>
                      <div
                        onClick={e => {
                          e.stopPropagation();
                          if (!hasSelectorPosting)
                            sendTrackingInfo('Panel', 'Mis avisos', 'Card del aviso-Ir al aviso');
                          if (hasSelectorPosting) {
                            setShowSelectPosting({
                              onImage: false,
                              onTitle: !showSelectPosting.onTitle,
                              onActionButton: false
                            });
                            if (!showSelectPosting.onImage && !showSelectPosting.onActionButton) {
                              setActiveShadow(!activeShadow);
                            }
                            if (menuOpenId) setMenuOpenId(null);
                          }
                        }}
                        data-panel='posting-action-irAviso-title'
                        className='posting-title-wrapper'
                      >
                        <PostingTitle
                          data-panel='posting-title'
                          href={!hasSelectorPosting ? linkToPostingUrl : null}
                          target='_blank'
                          rel='noopener noreferrer'
                          hasClonedPosting={hasSelectorPosting}
                        >
                          {posting.title !== 'GENERIC_TITLE' ? posting.title : t('panel.posting.no.title')}
                        </PostingTitle>
                        {hasSelectorPosting && showSelectPosting.onTitle && (
                          <OptionsSelector
                            isOpen={showSelectPosting.onTitle}
                            optionsArray={optionsPostingsArray()}
                            elementRef={positionRef2}
                            handleOutsideClick={handleOutsideClick}
                            height='94px'
                            topDown='52px'
                          />
                        )}
                      </div>
                      <div className='address posting-title-wrapper' data-panel='posting-address'>
                        {isExclusiveZone && <TagZonaDemand>{t('panel.posting.tagZonaDemand')}</TagZonaDemand>}
                        {address}
                      </div>
                      {pricesOperationTypes && pricesOperationTypes.length ? (
                        <Collapsible formatedPrice={formatedPrice} device={device} />
                      ) : (
                        <InfoLabel data-panel='posting-priceInfo-noPriceLabel' bold size='14px'>
                          {publicationType !== 'Emprendimiento' && t('panel.posting.no.price')}
                        </InfoLabel>
                      )}
                    </div>
                    <QualityArea
                      quality={quality}
                      qualityNotApply={qualityNotApply}
                      device={device}
                      isDuplicate={isDuplicate}
                      isPenalized={isPenalized}
                      qualityStatus={qualityStatus}
                      usedForTour={usedForTour}
                      validations={validations}
                      openModal={openModal}
                      tooltipText={t(`panel.avisos.posting.tooltip.${getTooltipText()}`, {
                        postingType: qualityNotApply ? realEstateType : null
                      })}
                      qualityText={t(`panel.avisos.posting.quality.${getQualityText()}`)}
                    />
                  </DescriptionArea>
                </InfoLabelsWrapper>
              </InfoLeftArea>
            </LeftArea>
            {getInfoRightSection()}
          </PostingBody>
          <PostingFooter>
            <BottomInfoRight
              posting={posting}
              device={device}
              isDraft={isDraft}
              isOnline={isOnline}
              newPublisherAccess={newPublisherAccess}
              isParticular={isParticular}
              openModal={openModal}
              isIntegrator={isIntegrator}
              postingStatus={status}
              isAssistant={isAssistant}
            />
            <ActionsArea
              showingModal={showModal.endModal || showModal.activationModal}
              isFreemiumFlow={isFreemiumFlow}
              postingId={postingId}
              newPublisherAccess={newPublisherAccess}
              linkToPostingUrl={linkToPostingUrl}
              status={status}
              isDeleted={isDeleted}
              userCanEditPermissions={userCanEditPermissions}
              siteId={siteId}
              lockedSoft={lockedSoft}
              redirectToEdit={redirectToEdit}
              isDraft={isDraft}
              openModal={openModal}
              isOnline={isOnline}
              isOpenThisMenu={isOpenThisMenu}
              setMenuOpenId={setMenuOpenId}
              device={device}
              isReservado={isReservado}
              handleReservation={handleReservation}
              handleCancelReservation={handleCancelReservation}
              usedForTour={usedForTour}
              isIntegrator={isIntegrator}
              isParticular={isParticular}
              withoutCreditState={withoutCreditState}
              isAssistant={isAssistant}
              finishReason={finishReasonByPosting}
              hasSelectorPosting={hasSelectorPosting}
              setActiveShadow={setActiveShadow}
              activeShadow={activeShadow}
              setShowSelectPosting={setShowSelectPosting}
              showSelectPosting={showSelectPosting}
              redirectToPosting={redirectToPosting}
              handleOutsideClick={handleOutsideClick}
              optionsPostingsArray={optionsPostingsArray()}
            />
          </PostingFooter>
        </CardContainer>
        {totalReport > 0 && (
          <ReportContainer
            data-panel='posting-reportAlert'
            hasUncheckedReport={processedReportCounts.countNew}
            device={device}
          >
            <Alert hasUncheckedReport={processedReportCounts.countNew} />
            <ReportMessage hasUncheckedReport={processedReportCounts.countNew}>
              {!processedReportCounts.countNew ? (
                <div>
                  {t('panel.avisos.report.message')} {<b>{processedReportCounts.countChecked}</b>}{' '}
                  {t(`panel.avisos.report.message.end${processedReportCounts.countChecked > 1 ? '.plural' : ''}`)}
                </div>
              ) : (
                <div>
                  {t('panel.avisos.report.new.message')}{' '}
                  {
                    <b>
                      {processedReportCounts.countNew}{' '}
                      {t(`panel.avisos.report.new.message.end${processedReportCounts.countNew > 1 ? '.plural' : ''}`)}
                    </b>
                  }
                </div>
              )}
              <button
                onClick={e => {
                  openModal(e, 'reportModal');
                  sendTrackingInfo('Panel', 'Mis avisos', `Card del aviso-Ver reportes`);
                }}
              >
                {t(`panel.avisos.report.message.see${totalReport > 1 ? '.plural' : ''}`)}
              </button>
            </ReportMessage>
          </ReportContainer>
        )}
      </PostingContainer>
    </>
  );
}

export default React.memo(MemoizedPosting);
